import React, { useMemo } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { audiences, nav } from '../mock';

const AudienceDetail = () => {
  const { slug } = useParams();
  const a = audiences[slug];
  const otherSectors = useMemo(
    () => nav.audiences.filter(x => x.slug !== slug),
    [slug]
  );
  if (!a) return <Navigate to="/who-we-serve" replace />;

  return (
    <div className="fade-in">
      <section className="hero-gradient border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 py-20">
          <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4">
            <Link to="/who-we-serve" className="hover:text-[#2E75B6]">Who We Serve</Link>
            <span className="mx-2 text-slate-400">/</span>
            <span className="text-slate-600">{a.title}</span>
          </div>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1F3864] max-w-4xl">{a.title}</h1>
          <p className="mt-5 text-[18px] text-slate-700 max-w-3xl">{a.hero}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-8 space-y-6 text-[16.5px] leading-[1.8] text-slate-700">
            {a.body.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
            <div className="mt-8">
              <h3 className="font-serif-display text-2xl text-[#1F3864] mb-4">Program Focus Areas</h3>
              <ul className="space-y-2.5">
                {a.focus.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <Check size={18} className="mt-1 text-[#2E75B6] flex-shrink-0" strokeWidth={2} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="pt-10">
              <Link to="/contact" className="inline-flex items-center gap-2 bg-[#1F3864] text-white text-[15px] font-medium px-6 py-3.5 rounded-sm hover:bg-[#17294a] transition-colors">
                Discuss Your Practice <ArrowRight size={16} />
              </Link>
            </div>
          </div>
          <aside className="md:col-span-4">
            <div className="sticky top-24 border border-slate-200 rounded-sm p-6 bg-slate-50">
              <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4">Other Sectors</div>
              <ul className="space-y-2">
                {otherSectors.map(x => (
                  <li key={x.slug}>
                    <Link to={`/who-we-serve/${x.slug}`} className="block text-[14.5px] text-slate-700 hover:text-[#1F3864] py-1.5 border-b border-slate-200 last:border-0">
                      {x.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default AudienceDetail;
